import { type RefObject, useEffect, useState } from "react";

const NAVIGATION_HEADER_HEIGHT_PX = 64;

export const useScrolledPastHero = (
	heroRef: RefObject<HTMLElement | null>,
	topOffsetPx: number = NAVIGATION_HEADER_HEIGHT_PX,
) => {
	const [scrolledPast, setScrolledPast] = useState(false);

	useEffect(() => {
		const element = heroRef.current;
		if (!element) return;

		const observer = new IntersectionObserver(
			([entry]) => setScrolledPast(!entry.isIntersecting),
			{ rootMargin: `-${topOffsetPx}px 0px 0px 0px`, threshold: 0 },
		);
		observer.observe(element);
		return () => observer.disconnect();
	}, [heroRef, topOffsetPx]);

	return scrolledPast;
};
